module.exports = __webpack_public_path__ + "img/Mono Logo(en)_Dark.fce9b3bb.svg";